define(function(require, exports, module) {
    'use strict';
    const core = require('core');

    module.exports = {
        notify: function(options) {
            const { id, onSuccess, onClose, showOldPassword } = options.data;
            const popupId = id || 'change-password-popup';
            const handler = (data) => {
                window.Playtech.API.popup.closePopups(popupId);

                onSuccess(data.password);
            };

            window.Playtech.API.popup.showPopup({
                id: popupId,
                layer: 'LOGIN',
                title: 'playtech.mobile.system.changePass.title',
                content: `<hub2-change-password ${showOldPassword ? 'args=showOldPassword' : ''} />`,
                buttons: false,
                closeAll: true,
                onClose: () => {
                    core.off('user:password-changed', handler);
                    onClose();
                }
            });

            core.once('user:password-changed', handler);
        }
    };
});
